import { PaymentHistory } from "@arelia-types/subscriptions";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { http } from "src/api/http";
import PaymentHistoryPresenter from "./PaymentHistoryPresenter";
import { useSubscriptionDetailsAPI } from "@arelia-components/SubscriptionDetails/useSubscriptionDetailsAPI";

export default function PaymentHistoryContainer() {
  const { id } = useParams();
  const { data, isLoading } = useQuery<PaymentHistory[]>({
    queryKey: ["subscriptionsHistory"],
    queryFn: () => http(id ? `/api/subscriptions/${id}/history` : `/api/subscriptions/history`)
  });
  
  const { data: subscription } = useSubscriptionDetailsAPI(id);

  return <PaymentHistoryPresenter 
    data={data} 
    isLoading={isLoading} 
    isFreePlan={subscription?.isFreePlan ?? false}
  />;
}
